import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import {
  DANGEROUS_RED,
  PRIMARY_GRAY,
  WARNING_ORANGE
} from "@pathwright/ui/src/components/utils/colors"
import classnames from "classnames"
import get from "lodash/get"
import moment from "moment"
import styled from "styled-components"

const StyledContainer = styled.div`
  padding-right: 1em;
`

const StyledInnerContainer = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: ${(p) => (p.mobile ? "10px" : "12px")};
  padding-top: 1em;
  padding-bottom: 1em;

  .Pathicon {
    margin-right: 0.25em;
  }
`

const PathDue = ({ pathItem, inverted, className, isMobile, ...rest }) => {
  const { tc } = useTranslate()

  if (!pathItem.due || pathItem.passive_due) return null

  // completed user path item
  if (get(pathItem, "completion.user") && get(pathItem, "progress") >= 1)
    return null

  let color = null
  if (inverted) {
    color = "white"
  } else if (moment().isAfter(pathItem.due)) {
    color = DANGEROUS_RED
  } else if (moment().add(3, "days").isAfter(pathItem.due)) {
    color = WARNING_ORANGE
  } else {
    color = PRIMARY_GRAY
  }

  return (
    <StyledContainer className={classnames("PathDue", className)} {...rest}>
      <Tooltip
        title={tc("due {{ fromNowDate }}", {
          fromNowDate: moment(pathItem.due).fromNow()
        })}
        placement="left"
      >
        <StyledInnerContainer mobile={isMobile} style={{ color }}>
          <Pathicon style={{}} icon="flag" />{" "}
          {moment(pathItem.due).fromNow(true /* don't show the suffix */)}
        </StyledInnerContainer>
      </Tooltip>
    </StyledContainer>
  )
}

PathDue.displayName = "PathDue"

export default PathDue
